import Axios from '../../../../common/util/Axios';
import store from '../../../../store';

const companyParams = () => {
  const { companyId, branchId } = store.getState().authState;
  return { companyId, branchId };
};

const unwrap = (res) => {
  if (Array.isArray(res?.data?.data)) return res.data.data;
  if (res?.data?.data != null) return res.data.data;
  if (Array.isArray(res?.data)) return res.data;
  return res?.data;
};

export const fetchModifierGroups = async () => {
  const res = await Axios.get('/api/dashboard/modifiers/groups', {
    params: companyParams(),
  });
  return unwrap(res) || [];
};

export const createModifierGroup = async (body) => {
  const res = await Axios.post('/api/dashboard/modifiers/groups', body, {
    params: companyParams(),
  });
  return unwrap(res);
};

export const updateModifierGroup = async (id, body) => {
  const res = await Axios.put(`/api/dashboard/modifiers/groups/${id}`, body, {
    params: companyParams(),
  });
  return unwrap(res);
};

export const deleteModifierGroup = async (id) => {
  await Axios.delete(`/api/dashboard/modifiers/groups/${id}`, {
    params: companyParams(),
  });
  return true;
};

export const createModifierOption = async (body) => {
  const res = await Axios.post('/api/dashboard/modifiers/options', body, {
    params: companyParams(),
  });
  return unwrap(res);
};

export const updateModifierOption = async (id, body) => {
  const res = await Axios.put(`/api/dashboard/modifiers/options/${id}`, body, {
    params: companyParams(),
  });
  return unwrap(res);
};

export const deleteModifierOption = async (id) => {
  await Axios.delete(`/api/dashboard/modifiers/options/${id}`, {
    params: companyParams(),
  });
  return true;
};

export const fetchGroupsForProduct = async (productId) => {
  const res = await Axios.get('/api/dashboard/modifiers/groups-for-product', {
    params: { ...companyParams(), productId },
  });
  return unwrap(res) || [];
};
